import { selectTab } from "@/state/functions";
import { actions, RootState } from "@/state/reducer";
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { dataWriter } from "@/functions/data";

const TestStepThree = () => {
  const State = useSelector((state: RootState) => state);
  const text = State.text;

  const [isRecording, setIsRecording] = useState(false);
  const [audioURL, setAudioURL] = useState("");
  const [base64Audio, setBase64Audio] = useState(""); // Состояние для Base64
  
  const mediaRecorderRef = useRef<MediaRecorder | null>(null);
  const audioChunksRef = useRef<Blob[]>([]); // Изменено на Blob для удобства сборки

  // --- Функции преобразования ---

  const encodeAudioToState = async (blob: Blob) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64String = reader.result as string;
      setBase64Audio(base64String);
      console.log("Encoded to Base64");
    };
  };

  useEffect(() => {
    if (base64Audio) {
      dataWriter.writeAudioDataReady(base64Audio)
    }
  }, [base64Audio])

  const handleBase64InputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    setBase64Audio(value);

    // Попытка сразу "раскодировать" для проигрывания, если это валидный data-url
    if (value.startsWith("data:audio")) {
      setAudioURL(value);
    }
  };

  // --- Логика записи ---

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      audioChunksRef.current = [];

      const mediaRecorder = new MediaRecorder(stream, {
        mimeType: "audio/webm;codecs=opus",
      });
      mediaRecorderRef.current = mediaRecorder;

      mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          audioChunksRef.current.push(event.data);
          // Для вашего dataWriter (если он ожидает Uint8Array)
          // event.data.arrayBuffer().then(buf => dataWriter.writeAudioData(new Uint8Array(buf)));
        }
      };

      mediaRecorder.onstop = () => {
        const audioBlob = new Blob(audioChunksRef.current, { type: "audio/webm" });
        const url = URL.createObjectURL(audioBlob);
        setAudioURL(url);
        
        // Автоматически кодируем в Base64 после остановки
        encodeAudioToState(audioBlob);
      };

      mediaRecorder.start();
      setIsRecording(true);
    } catch (error) {
      console.error("Ошибка доступа к микрофону:", error);
      alert("Разрешите доступ к микрофону");
    }
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current && isRecording) {
      mediaRecorderRef.current.stop();
      mediaRecorderRef.current.stream.getTracks().forEach((track) => track.stop());
      setIsRecording(false);
    }
  };

  const [finishing, setFinishing] = useState(false);

  const finishTest = async () => {
    setFinishing(true);
    dataWriter.writeAudioDataReady(base64Audio);
    // Дожидаемся отправки результата, чтобы прогресс на старте был актуален
    await dataWriter.downloadTestDataJson();
    setFinishing(false);
    selectTab("finish");
  };

  return (
    <div className="page greeting gridCenter w100">
      <div className="inner columnCenter gap24" style={{ maxWidth: '600px' }}>
        <h1>Произнесите текст СВОИМ голосом</h1>
        <div style={{ fontStyle: 'italic', color: '#666' }}>{text}</div>

        <div className="controls rowCenter gap12">
          {!isRecording ? (
            <button className="btn mainBtn" onClick={startRecording}>Начать запись</button>
          ) : (
            <button className="btn mainBtn" onClick={stopRecording} style={{ background: 'red' }}>Остановить запись</button>
          )}
        </div>

        {/* Поле для Base64 */}
        <div className="columnCenter w100 gap12" style={{ display: 'none' }}>
          <label>Base64 аудио данные:</label>
          <textarea 
            rows={5} 
            className="w100"
            style={{ width: '100%', fontSize: '10px', fontFamily: 'monospace' }}
            value={base64Audio}
            onChange={handleBase64InputChange}
            placeholder="Здесь появится Base64 или вставьте свой..."
          />
        </div>

        {audioURL && (
          <div className="columnCenter gap12">
            <p>Предпросмотр аудио:</p>
            <audio controls src={audioURL} key={audioURL} />
          </div>
        )}

        <div className="rowCenter gap12">
          <button className="btn mainBtn" onClick={finishTest} disabled={finishing}>
            {finishing ? "Отправка..." : "Завершить тест"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TestStepThree;